import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'eligibilitymodal.title',
    defaultMessage: 'Details not found',
  },
  description: {
    id: 'eligibilitymodal.description',
    defaultMessage:
      'We can’t seem to find you on the {name} system. Check your details and try again, or contact support and we’ll do our best to help you.',
  },
})
